import { FormattedMessage } from "react-intl";
import { Box, Grid, MenuItem, TextField } from "@material-ui/core";
import { ErrorMessage, Form, Formik } from "formik";
import clsx from "clsx";
import { MyTextField } from "../../components/custom/MyTextField";
import DragDrop from "../../components/pqrs/dragdrop";
import usePqrs from "./usePqrs";
import Mia from "../../components/pqrs/mia";
import Recaptcha from "../../components/pqrs/recaptcha";
import SubmitButton from "../../components/pqrs/submit-button";
import SendEmailCheckbox from "../../components/pqrs/send-email-checkbox";
import PrivacyPolicyCheckbox from "../../components/pqrs/privacy-policy-checkbox";
import HeaderLogo from "../../components/pqrs/header-logo";
import FormHeader from "../../components/pqrs/form-header";

function Pqrs() {
  const {
    classes,
    initialData,
    someValidationSchema,
    allRequiredValidationSchema,
    handleSelectCountry,
    handleSelectDepartment,
    handleRecaptcha,
    intl,
    entityData,
    isAnonymous,
    setIsAnonymous,
    listCountries,
    listDepartments,
    listCities,
    optionsCommunicationType,
    recaptcha,
    setFiles,
    send,
  } = usePqrs();

  return (
    <>
      <HeaderLogo logoUrl={entityData?.logoUrl} />
      <Box className={classes.pqrsForm}>
        <Box className="pqrs-form" marginRight={"auto"} marginLeft={"auto"}>
          <Grid container item md={12}>
            <Grid item md={7} sm={12}>
              <Box paddingY={"24px"}>
                <FormHeader setIsAnonymous={setIsAnonymous} />
                <Grid container item md={12}>
                  <Formik
                    validateOnChange={true}
                    validationSchema={
                      isAnonymous
                        ? someValidationSchema
                        : allRequiredValidationSchema
                    }
                    initialValues={initialData}
                    onSubmit={async (
                      values,
                      { setSubmitting, resetForm, setFieldValue }
                    ) => {
                      setSubmitting(true);

                      let country = listCountries.find(
                        (data) => data.id === values.country
                      );
                      values.country = country?.name.toString() || "";

                      let depto = listDepartments.find(
                        (data) => data.id === values.department
                      );
                      values.department = depto?.name.toString() || "";

                      let city = listCities.find(
                        (data) => data.id === values.city
                      );
                      values.city = city?.name.toString() || "";

                      await send(values);
                      setSubmitting(false);
                    }}
                  >
                    {({
                      setFieldValue,
                      isSubmitting,
                      setFieldError,
                      submitCount,
                      values,
                    }) => (
                      <Form>
                        {!isAnonymous && (
                          <div>
                            <Grid>
                              <FormattedMessage id="NamePersonEntity" />*
                              <MyTextField
                                placeholder={intl.formatMessage({
                                  id: "EnterNameOrCompany",
                                })}
                                name="name"
                                variant="outlined"
                                className={clsx(
                                  classes.myTextFieldRoot,
                                  classes.customFormField
                                )}
                              />
                            </Grid>
                            <Grid container item md={12}>
                              <Grid item xs={12} md={6} className="mt-1">
                                <Box marginRight={{ xs: "0rem", md: "0.3rem" }}>
                                  <FormattedMessage id="Identification" />*
                                  <MyTextField
                                    placeholder={intl.formatMessage({
                                      id: "EnterYourIdNumber",
                                    })}
                                    name="identificationNumber"
                                    variant="outlined"
                                    className={clsx(
                                      classes.myTextFieldRoot,
                                      classes.customFormField
                                    )}
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={12} md={6} className="mt-1">
                                <Box marginLeft={{ xs: "0rem", md: "0.3rem" }}>
                                  <FormattedMessage id="Phone" />*
                                  <MyTextField
                                    placeholder={intl.formatMessage({
                                      id: "EnterYourPhone",
                                    })}
                                    type="numeric"
                                    name="phone"
                                    variant="outlined"
                                    className={clsx(
                                      classes.myTextFieldRoot,
                                      classes.customFormField
                                    )}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                            <Grid container item md={12}>
                              <Grid item xs={12} md={6} className="mt-1">
                                <Box marginRight={{ xs: "0rem", md: "0.3rem" }}>
                                  <FormattedMessage id="Email" />*
                                  <MyTextField
                                    placeholder={intl.formatMessage({
                                      id: "EnterYourEmail",
                                    })}
                                    name="email"
                                    variant="outlined"
                                    className={clsx(
                                      classes.myTextFieldRoot,
                                      classes.customFormField
                                    )}
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={12} md={6} className="mt-1">
                                <Box marginLeft={{ xs: "0rem", md: "0.3rem" }}>
                                  <FormattedMessage id="ConfirmYourEmail" />*
                                  <MyTextField
                                    placeholder={intl.formatMessage({
                                      id: "PleaseConfirmYourEmail",
                                    })}
                                    name="emailConfirm"
                                    variant="outlined"
                                    className={clsx(
                                      classes.myTextFieldRoot,
                                      classes.customFormField
                                    )}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                            <Grid container item md={12}>
                              <Grid item xs={12} md={6} className="mt-1">
                                <Box marginRight={{ xs: "0rem", md: "0.3rem" }}>
                                  <FormattedMessage id="Direction" />*
                                  <MyTextField
                                    placeholder={intl.formatMessage({
                                      id: "WriteYourAddress",
                                    })}
                                    name="address"
                                    variant="outlined"
                                    className={clsx(
                                      classes.myTextFieldRoot,
                                      classes.customFormField
                                    )}
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={12} md={6} className="mt-1">
                                <Box marginLeft={{ xs: "0rem", md: "0.3rem" }}>
                                  <FormattedMessage id="Country" />*
                                  <TextField
                                    placeholder={intl.formatMessage({
                                      id: "Select",
                                    })}
                                    select
                                    name="country"
                                    variant="outlined"
                                    type="select"
                                    value={values.country}
                                    className={clsx(
                                      classes.myTextFieldRoot,
                                      classes.customFormField
                                    )}
                                    onChange={(e: any) => {
                                      setFieldValue("country", e.target.value);
                                      setFieldError("country", "");
                                      handleSelectCountry(e);
                                    }}
                                  >
                                    <MenuItem key="" value="">
                                      {intl.formatMessage({ id: "Select" })}
                                    </MenuItem>
                                    {listCountries.map((country, index) => (
                                      <MenuItem key={index} value={country.id}>
                                        {country.name}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                  <ErrorMessage
                                    className="field-error"
                                    name="country"
                                    component="div"
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                            <Grid container item md={12}>
                              <Grid item xs={12} md={6} className="mt-1">
                                <Box marginRight={{ xs: "0rem", md: "0.3rem" }}>
                                  <label className="form-text">
                                    <FormattedMessage id="Department" />*
                                  </label>
                                  <TextField
                                    placeholder={intl.formatMessage({
                                      id: "Select",
                                    })}
                                    name="department"
                                    variant="outlined"
                                    select
                                    value={values.department}
                                    className={clsx(
                                      classes.myTextFieldRoot,
                                      classes.customFormField
                                    )}
                                    onChange={(e: any) => {
                                      setFieldValue(
                                        "department",
                                        e.target.value
                                      );
                                      handleSelectDepartment(e);
                                    }}
                                  >
                                    <MenuItem key="" value="">
                                      {intl.formatMessage({ id: "Select" })}
                                    </MenuItem>
                                    {listDepartments.map((depart, index) => (
                                      <MenuItem key={index} value={depart.id}>
                                        {depart.name}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                  <ErrorMessage
                                    className="field-error"
                                    name="department"
                                    component="div"
                                  />
                                </Box>
                              </Grid>
                              <Grid item xs={12} md={6} className="mt-1">
                                <Box marginLeft={{ xs: "0rem", md: "0.3rem" }}>
                                  <label className="form-text">
                                    <FormattedMessage id="City" />*
                                  </label>
                                  <MyTextField
                                    name="city"
                                    variant="outlined"
                                    select
                                    value={values.city}
                                    className={clsx(
                                      classes.myTextFieldRoot,
                                      classes.customFormField
                                    )}
                                  >
                                    <MenuItem key="" value="">
                                      {intl.formatMessage({ id: "Select" })}
                                    </MenuItem>
                                    {listCities.map((city, index) => (
                                      <MenuItem key={index} value={city.id}>
                                        {city.name}
                                      </MenuItem>
                                    ))}
                                  </MyTextField>
                                </Box>
                              </Grid>
                            </Grid>
                          </div>
                        )}
                        <Grid item md={12} className="mt-1">
                          <label className="form-text">
                            <FormattedMessage id="RequestForm" />*
                          </label>
                          <MyTextField
                            name="communicationType"
                            variant="outlined"
                            select
                            className={clsx(
                              classes.myTextFieldRoot,
                              classes.customFormField
                            )}
                          >
                            {optionsCommunicationType.map((item) => (
                              <MenuItem key={item.option} value={item.option}>
                                {intl.formatMessage({ id: item.option })}
                              </MenuItem>
                            ))}
                          </MyTextField>
                        </Grid>
                        <Grid item md={12} className="mt-1">
                          <label className="form-text">
                            <FormattedMessage id="RequestFormDescription" />*
                          </label>
                          <MyTextField
                            name="description"
                            variant="outlined"
                            minRows={6}
                            multiline
                            className={clsx(
                              classes.myTextFieldRoot,
                              classes.customFormField,
                              classes.customTextArea
                            )}
                          />
                        </Grid>
                        <Box marginTop={"2rem"}>
                          <DragDrop
                            onFilesSelected={(files) => setFiles(files)}
                            width="100%"
                            height="400px"
                          />
                        </Box>
                        <PrivacyPolicyCheckbox
                          PPUrl={entityData?.PPUrl}
                          onChange={(value: boolean) => {
                            setFieldValue("privacyPolicy", value);
                          }}
                        />
                        <SendEmailCheckbox
                          isChecked={values.receiveEmail}
                          onChange={(value: boolean) => {
                            setFieldValue("receiveEmail", value);
                          }}
                        />
                        <Recaptcha
                          recaptcha={recaptcha}
                          submitCount={submitCount}
                          handleRecaptcha={handleRecaptcha}
                        />
                        <SubmitButton isLoading={isSubmitting} />
                      </Form>
                    )}
                  </Formik>
                </Grid>
              </Box>
            </Grid>
            <Mia miaUrl={entityData?.miaUrl} />
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default Pqrs;
